import styled from 'styled-components';

export const Header = styled.div`
  width: 100%;
  margin-top: 0;
  padding: 20px 40px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  @media (max-width: 450px) {
    img {
      width: 40%;
      height: 40%;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  background: #ebf1ed;
  padding: 10px;
  border-radius: 8px;
  img {
    align-self: center;
  }
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  h1 {
    margin-top: 22px;
    font-size: 22px;
    text-align: center;
  }
  h2,
  h3,
  h4 {
    margin-top: 12px;
    text-align: center;
  }

  a {
    text-decoration: none;
    font-weight: 500;
    color: #fff;
  }

  @media (max-width: 680px), (max-width: 450px) {
    h1 {
      margin: 0;
      font-size: 14px;
    }

    h2 {
      margin: 5px 0;

      font-size: 16px;
    }

    span {
      font-size: 16px;
      text-align: center;
    }
  }
`;
